import { Dispatch, SetStateAction, useRef, useState } from "react";
import { TransfereCompromissoController } from "../../../../Controllers/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import UnForm from "../../../Form";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { ListarTipoCompromissoController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import { ITransferirTodosAgendamentos } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";

interface ITransferirAgendamentosMassaProps {
    setShow: Dispatch<SetStateAction<boolean>>;

    updateList: () => void;
    idCaso?: number;

    setAtualizaAgenda?: Dispatch<SetStateAction<boolean>>;
}

export default function TransferirAgendamentosMassa(
    props: ITransferirAgendamentosMassaProps
) {
    const { execute: TransferirAgendamentosEmMassa } = useAsyncCallback(
        TransfereCompromissoController
    );
    const [loading, setLoading] = useState(false);

    const agendaWindowRef = useRef<Window>();

    function handleTransferirAgendamentosMassa(
        formData: ITransferirTodosAgendamentos
    ) {
        setLoading(true);
        TransferirAgendamentosEmMassa(
            formData.ID_TIPO_COMPROMISSO ?? 0,
            formData.ID_USUARIO_REMETENTE ?? 0,
            formData.ID_USUARIO_DESTINATARIO ?? 0
        ).then(() => {
            props.updateList();
            props.setShow(false);
            agendaWindowRef.current?.close();
            setLoading(false);
        });
    }

    return (
        <UnForm handleSubmit={handleTransferirAgendamentosMassa}>
            <div className="row">
                <div className="col-md-4">
                    <UnForm.LazySelect
                        wrapperClassName="p-2 col-12 mb-3"
                        className="mb-4"
                        label="De:"
                        name="ID_USUARIO_REMETENTE"
                        controller={ListarUsuariosController}
                        getKeyValue={(u) => u.ID_USUARIO}
                        getDS={(u) => u.DS_NOME}
                    ></UnForm.LazySelect>
                </div>
                <div className="col-md-4">
                    <UnForm.LazySelect
                        wrapperClassName="p-2 col-12 mb-3"
                        className="mb-4"
                        label="Para:"
                        name="ID_USUARIO_DESTINATARIO"
                        controller={ListarUsuariosController}
                        getKeyValue={(u) => u.ID_USUARIO}
                        getDS={(u) => u.DS_NOME}
                    ></UnForm.LazySelect>
                </div>
                <div className="col-md-4">
                    <UnForm.LazySelect
                        wrapperClassName="p-2 col-12 mb-3"
                        className="mb-4"
                        label="Tipo Compromisso"
                        name="ID_TIPO_COMPROMISSO"
                        controller={ListarTipoCompromissoController}
                        getKeyValue={(u) => u.ID_TIPO_COMPROMISSO}
                        getDS={(u) => u.DS_TIPO_COMPROMISSO}
                    ></UnForm.LazySelect>
                </div>
            </div>
            <UnForm.SubmitButton
                color="primary"
                icon={faExchangeAlt}
                className="col-12"
                disabled={loading}
                loading={loading}
                loadingSize={"sm"}
            >
                Transferir Todos Agendamentos
            </UnForm.SubmitButton>
        </UnForm>
    );
}
